import { render, staticRenderFns } from "./BulletinDocumentsComponent.vue?vue&type=template&id=5be92586&scoped=true&"
import script from "./BulletinDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinDocumentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinDocumentsComponent.vue?vue&type=style&index=0&id=5be92586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be92586",
  null
  
)

export default component.exports